export default "__VITE_ASSET__B_86MDyZ__"